import React from "react";
import emailjs from "@emailjs/browser";

export default function ModalReservaTour({ data, onClose }) {
    const handleConfirm = () => {
        const templateParams = {
            fullName: data.fullName,
            phone: data.phone,
            email: data.email,
            package: data.package,
            numberOfPeople: data.numberOfPeople,
            tourDate: data.tourDate,
            paymentMethod: data.paymentMethod,
        };

        emailjs
            .send(
                "tu_service_id",       // Reemplaza con tu Service ID
                "tu_template_id",      // Reemplaza con tu Template ID
                templateParams,
                "tu_public_key"        // Reemplaza con tu Public Key
            )
            .then(
                (response) => {
                    alert("¡Reservación enviada correctamente!");
                    onClose();
                },
                (error) => {
                    alert("Error al enviar la reservación.");
                    console.error(error);
                }
            );
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full my-10 max-h-[90vh] overflow-y-auto">
                <h2 className="text-2xl font-bold mb-4 text-primary-800">Confirmar reservación</h2>
                <div className="text-primary-800 space-y-2 mb-4">
                    <p><strong>Nombre Completo:</strong> {data.fullName}</p>
                    <p><strong>Teléfono:</strong> {data.phone}</p>
                    <p><strong>Correo Electrónico:</strong> {data.email}</p>
                    <p><strong>Tour Seleccionado:</strong> {data.package}</p>
                    <p><strong>Número de Personas:</strong> {data.numberOfPeople}</p>
                    <p><strong>Fecha del Tour:</strong> {data.tourDate}</p>
                    <p><strong>Método de Pago:</strong> {data.paymentMethod}</p>
                </div>

                

                {data.paymentMethod === "Billetera_digital" && (
                    <div>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/yape_imagen.webp`}
                            className="w-[40%] rounded-lg"
                            alt="Yape"
                        />
                    </div>
                )}

                {data.paymentMethod === "Transferencia_bancaria" && (
                    <div>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/bcp_cuenta.jpeg`}
                            className="w-[100%] rounded-lg"
                            alt="BCP"
                        />
                    </div>
                )}

                <div className="mb-4 borde-2 border-2 border-primary-800 p-4 rounded-lg">
                    <p className="mb-2 font-semibold">Nota: Para completar la reservación, es importante seguir los siguientes pasos:</p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Realizar la transferencia del monto correspondiente según el servicio elegido.</li>
                        <li>Enviar el comprobante de pago a través del siguiente enlace: <a href="https://tuenlace.com" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://whatsapp_pagos.com</a></li>
                        <li>Terminado el paso anterior dar clic en <strong>Confirmar</strong></li>
                    </ul>
                </div>

                <div className="mt-4 flex justify-between">
                    <button
                        className="px-4 py-2 bg-red-700 text-white rounded"
                        onClick={onClose}
                    >
                        Cerrar
                    </button>
                    <button
                        className="px-4 py-2 bg-green-800 text-white rounded"
                        onClick={handleConfirm}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
}
